import React from 'react';

import { bem } from 'helpers/class-name';
import Message from 'components/Message';
import Isvg from 'react-inlinesvg';

import AnimatedHourglass from 'components/AnimatedHourglass';
import Callout from 'components/Callout';
import { ICONS } from 'constants/icons';
import messages from '../ReservationFeedbackModalV2.messages';

import './ProcessingReport.scss';

const { block, element } = bem('processing-report');

const ProcessingReport = () => {
  return (
    <div className={block()}>
      <div className={element('wrapper')}>
        <div className={element('time-wrapper')}>
          <div className={element('icon-wrapper')}>
            <div className={element('pulse')} />
            <AnimatedHourglass autoPlay size="lg" />
          </div>
          <div className={element('text-wrapper')}>
            <h3 className={element('title')}>
              <Message message={messages.processingReportTitle} />
            </h3>
            <p className={element('description')}>
              <Message message={messages.processingReportDescription} />
            </p>
          </div>
        </div>

        <Callout icon={<Isvg src={ICONS.timer} />}>
          <Message message={messages.processingReportCallout} />
        </Callout>
      </div>
    </div>
  );
};

export default ProcessingReport;
